import React from 'react';

function PageHeader({ title, breadcrumbs }) {
  return (
    <>
      {/* Page Header Start */}
      <div
        className="container-fluid page-header py-5 mb-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container text-center py-5">
          <h1 className="display-4 text-white animated slideInDown mb-3">
            {title}
          </h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb justify-content-center mb-0">
              {breadcrumbs && breadcrumbs.map((crumb, index) => (
                <li
                  key={index}
                  className={`breadcrumb-item ${crumb.active ? 'text-primary active' : ''}`}
                  aria-current={crumb.active ? "page" : undefined}
                >
                  {crumb.active ? (
                    crumb.label
                  ) : (
                    <a className="text-white" href={crumb.link}>
                      {crumb.label}
                    </a>
                  )}
                </li>
              ))}
            </ol>
          </nav>
        </div>
      </div>
      {/* Page Header End */}
    </>
  );
}

export default PageHeader;
